var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m0,0l661,0l0,661l-661,0l0,-661z",
    transform: "scale(0.0378200002014637) ",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 602,
    width: 802,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    transform: "scale(0.9599999785423279) ",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "none",
    d: "m0,0l25,0l0,25l-25,0l0,-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    id: "svg_4",
    d: "m23.45,12.481l-4.577,6.997l-2.383,0l3.971,-6.014l-12.065,0c-0.718,0 -1.323,0.19 -1.929,0.53c-0.642,0.378 -1.096,0.832 -1.437,1.437c-0.378,0.605 -0.53,1.173 -0.53,1.891l0,0.19c0,0.415 0.039,0.794 0.19,1.21l0.908,2.76l-2.118,0l-0.719,-2.23a6.103,6.103 0 0 1 -0.265,-1.854c0,-1.06 0.265,-1.967 0.794,-2.912c0.568,-0.946 1.249,-1.665 2.194,-2.194c0.946,-0.567 1.891,-0.794 2.988,-0.794l11.99,0l-3.972,-6.014l2.383,0l4.576,6.997l0.001,0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinShareIcon);
export default __webpack_public_path__ + "static/media/linkedin-share-icon.3e53ca42da0b75553f3266af1c174aa3.svg";
export { ForwardRef as ReactComponent };